module.exports = __webpack_public_path__ + "img/6ee9998.png";